import { createPositionHttpRepository } from '@src/main/modules/parameters/infrastructure/repository/PositionHttpRepository';
import { TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

export const deletePositionUseCase = async (
  id: string,
  tokenProvider: TokenProvider,
): Promise<void> => {
  const repository = createPositionHttpRepository(tokenProvider);
  await repository.delete(id);
};
